import { render, staticRenderFns } from "./FormToolbar.vue?vue&type=template&id=148a75c8&lang=pug&"
import script from "./FormToolbar.vue?vue&type=script&lang=js&"
export * from "./FormToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormToolbar.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VSpacer,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
})
